import script from "./upgrade-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./upgrade-modal.vue?vue&type=script&setup=true&lang=js"

import "./upgrade-modal.vue?vue&type=style&index=0&id=ed3221ec&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed3221ec"]])

export default __exports__